export const getLoading = state => state.loading
export const getCurrent = state => state.currentPage
export const getHeaderStatus = state => state.headerStatus
export const getRoleId = state => state.roleId
export const getRoleCode = state => state.roleCode




// WEBPACK FOOTER //
// ./src/vuex/modules/app/getters.js